import { Component, OnInit } from '@angular/core';
  import maplibregl from 'maplibre-gl';
  import MapboxDraw from '@mapbox/mapbox-gl-draw';
  
  
@Component({
  selector: 'app-mapeditortest',
  templateUrl: './mapeditortest.component.html',
  styleUrl: './mapeditortest.component.css'
})
export class MapeditortestComponent  implements OnInit {
    map: any;
    draw: any;
  
    ngOnInit(): void {
      this.map = new maplibregl.Map({
        container: 'map',
        style: 'https://demotiles.maplibre.org/style.json',
        center: [77.6769, 12.8563],
        zoom: 13
      });
  
      // Initialize draw tools
      this.draw = new MapboxDraw({
        displayControlsDefault: false,
        controls: {
          polygon: true,
          line_string: true,
          point: true,
          trash: true,
          combine_features: true,
          uncombine_features: true
        },

        styles: this.getCustomDrawStyles()
      });
  
      this.map.addControl(this.draw);
  
      // Sample dynamic layers
      this.map.on('load', () => {
        this.loadLayer('buildings', '/assets/buildings.geojson', 'fill', {
          'fill-color': '#888',
          'fill-opacity': 0.4
        });
  
        this.loadLayer('roads', '/assets/roads.geojson', 'line', {
          'line-color': '#f00',
          'line-width': 2
        });
      });
  
      this.map.on('draw.create', this.logDrawEvent.bind(this));
      this.map.on('draw.update', this.logDrawEvent.bind(this));
    }
  
    getCustomDrawStyles() {
      return [
        {
          id: 'gl-draw-polygon-fill-inactive',
          type: 'fill',
          filter: ['all', ['==', '$type', 'Polygon'], ['!=', 'mode', 'static']],
          paint: {
            'fill-color': '#fbb03b',
            'fill-opacity': 0.4
          }
        },
        {
          id: 'gl-draw-polygon-stroke-inactive',
          type: 'line',
          filter: ['all', ['==', '$type', 'Polygon'], ['!=', 'mode', 'static']],
          paint: {
            'line-color': '#fbb03b',
            'line-width': 2
          }
        },
        {
          id: 'gl-draw-line-inactive',
          type: 'line',
          filter: ['all', ['==', '$type', 'LineString'], ['!=', 'mode', 'static']],
          paint: {
            'line-color': '#fbb03b',
            'line-width': 2
          }
        },
        {
          id: 'gl-draw-point-inactive',
          type: 'circle',
          filter: ['all', ['==', '$type', 'Point'], ['!=', 'mode', 'static']],
          paint: {
            'circle-radius': 5,
            'circle-color': '#fbb03b'
          }
        }
      ];
    }
    logDrawEvent(e: any): void {
      const features = e.features;
      console.log('Drawn/Updated:', features);
      // Optionally send features to your Node.js backend
    }
  
    loadLayer(id: string, dataUrl: string, type: string, paint: any) {
      this.map.addSource(id, {
        type: 'geojson',
        data: dataUrl
      });
  
      this.map.addLayer({
        id: id + '-layer',
        type,
        source: id,
        paint
      });
    }
  }
  